import { GetterTree } from 'vuex';
import { RootState } from '../../state';
import { StripeState } from './state';

export const getters: GetterTree<StripeState, RootState> = {
  /**
   * Check if Stripe is currently loading
   */
  isStripeLoading: (state): boolean => {
    return state.isLoading;
  },

  /**
   * Check if Stripe is initialized and ready to use
   */
  isStripeReady: (state): boolean => {
    return state.stripe !== null && !state.isLoading && !state.error;
  },

  /**
   * Get any Stripe initialization error
   */
  stripeError: (state): string | null => {
    return state.error;
  }
};
